<template>
    <div>
        <div class="c-activity-page-summary-title">
            {{ trans("Available dates") }}
        </div>
        <div v-if="terms.length > 0">
            <activity-date
                :maxLen="maxLen"
                :activityTime="activityTime(terms)"
            />
        </div>
        <div v-if="terms.length > 1">
            <div
                v-if="!show"
                @click="show = !show"
                class="btn btn-text p-0 text-primary"
            >
                +{{ terms.length - 1 }}
                {{ trans("other dates") }}
            </div>
            <div v-for="(term, index) in terms.slice(1,)" :key="index">
                <activity-date
                    :maxLen="maxLen"
                    :activityTime="activityTime([terms[index]])"
                    v-if="show"
                />
            </div>
        </div>
    </div>
</template>

<script>
import ActivityDateTimeViewer from "./ActivityDateTimeViewer.vue";
export default {
    props: ["terms"],
    data: function () {
        return {
            show: false,
            formatActivityTime: this.$options.filters.formatActivityTime,
            maxLen: 46,
        };
    },
    methods: {
        activityTime(terms) {
            return this.formatActivityTime(terms);
        },
    },
    components: {
        "activity-date": ActivityDateTimeViewer,
    },
};
</script> 

<style scoped>
.auto {
    cursor: auto;
}
.pointer {
    cursor: pointer;
}
</style>